'use client';

import { Terminal, ShieldAlert, KeyRound } from 'lucide-react';

export default function LoginPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0d0d0f',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background dot grid */}
      <div
        style={{
          position: 'absolute', inset: 0, pointerEvents: 'none', opacity: 0.025,
          backgroundImage: 'radial-gradient(#22d3ee 1px, transparent 0)',
          backgroundSize: '24px 24px',
        }}
      />

      <div
        style={{
          width: '100%', maxWidth: '28rem',
          background: '#141417', border: '1px solid #2a2a35',
          borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0,0,0,0.6)',
          padding: '2rem', position: 'relative', zIndex: 10,
          textAlign: 'center',
        }}
      >
        {/* Header Logo */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', marginBottom: '2rem' }}>
          <div style={{ padding: '0.5rem', borderRadius: '0.5rem', background: 'rgba(34,211,238,0.1)', color: '#22d3ee', display: 'flex' }}>
            <Terminal size={24} />
          </div>
          <div style={{ textAlign: 'left' }}>
            <h1 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 700, color: '#f0f0f5', letterSpacing: '-0.02em', fontFamily: 'monospace' }}>
              WP Training Lab
            </h1>
            <p style={{ margin: 0, fontSize: '0.7rem', color: '#8b8ba8' }}>Passwordless Token Access</p>
          </div>
        </div>

        {/* Lock Icon */}
        <div style={{ display: 'inline-flex', padding: '1rem', borderRadius: '9999px', background: 'rgba(34,211,238,0.05)', border: '1px solid rgba(34,211,238,0.2)', color: '#22d3ee', marginBottom: '1.5rem' }}>
          <KeyRound size={36} />
        </div>

        <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#f0f0f5', marginBottom: '0.75rem', fontFamily: 'monospace' }}>
          Authorized Access Required
        </h2>

        <p style={{ fontSize: '0.85rem', color: '#8b8ba8', lineHeight: 1.5, marginBottom: '1.5rem', fontFamily: 'sans-serif' }}>
          Access to this platform requires a personalized login link with a single-use token provided directly by an administrator.
        </p>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.75rem 1rem', borderRadius: '0.75rem', background: '#0d0d0f', border: '1px solid #2a2a35', color: '#8b8ba8', fontSize: '0.75rem', fontFamily: 'monospace', textAlign: 'left' }}>
          <ShieldAlert size={18} style={{ color: '#22d3ee', flexShrink: 0 }} />
          <span>If you are a student or trainer, please check your invite link or contact your system administrator.</span>
        </div>
      </div>
    </div>
  );
}
